import { useState, useEffect } from 'react';

// Common codes relevant to IASC's actual markets — extend as needed.
const COUNTRY_CODES = [
  { code: '+1', label: '🇺🇸 +1 / 🇨🇦 +1' },
  { code: '+20', label: '🇪🇬 +20' },
  { code: '+27', label: '🇿🇦 +27' },
  { code: '+30', label: '🇬🇷 +30' },
  { code: '+31', label: '🇳🇱 +31' },
  { code: '+32', label: '🇧🇪 +32' },
  { code: '+33', label: '🇫🇷 +33' },
  { code: '+34', label: '🇪🇸 +34' },
  { code: '+36', label: '🇭🇺 +36' },
  { code: '+39', label: '🇮🇹 +39' },
  { code: '+40', label: '🇷🇴 +40' },
  { code: '+41', label: '🇨🇭 +41' },
  { code: '+43', label: '🇦🇹 +43' },
  { code: '+44', label: '🇬🇧 +44' },
  { code: '+45', label: '🇩🇰 +45' },
  { code: '+46', label: '🇸🇪 +46' },
  { code: '+47', label: '🇳🇴 +47' },
  { code: '+48', label: '🇵🇱 +48' },
  { code: '+49', label: '🇩🇪 +49' },
  { code: '+51', label: '🇵🇪 +51' },
  { code: '+52', label: '🇲🇽 +52' },
  { code: '+55', label: '🇧🇷 +55' },
  { code: '+61', label: '🇦🇺 +61' },
  { code: '+62', label: '🇮🇩 +62' },
  { code: '+63', label: '🇵🇭 +63' },
  { code: '+64', label: '🇳🇿 +64' },
  { code: '+65', label: '🇸🇬 +65' },
  { code: '+66', label: '🇹🇭 +66' },
  { code: '+81', label: '🇯🇵 +81' },
  { code: '+82', label: '🇰🇷 +82' },
  { code: '+84', label: '🇻🇳 +84' },
  { code: '+90', label: '🇹🇷 +90' },
  { code: '+91', label: '🇮🇳 +91' },
  { code: '+92', label: '🇵🇰 +92' },
  { code: '+93', label: '🇦🇫 +93' },
  { code: '+94', label: '🇱🇰 +94' },
  { code: '+95', label: '🇲🇲 +95' },
  { code: '+234', label: '🇳🇬 +234' },
  { code: '+254', label: '🇰🇪 +254' },
  { code: '+260', label: '🇿🇲 +260' },
  { code: '+263', label: '🇿🇼 +263' },
];

// value is the full combined string e.g. "+263 771234567". This component
// parses it apart on mount and recombines on change, so parent components
// can keep treating phone fields as a single string
export default function PhoneInput({ label, value, onChange, required }) {
  const parseValue = (v) => {
    const match = COUNTRY_CODES.find((c) => v?.startsWith(c.code));
    if (match) return { code: match.code, number: v.slice(match.code.length).trim() };
    return { code: '+263', number: v || '' };
  };

  const [code, setCode] = useState(() => parseValue(value).code);
  const [number, setNumber] = useState(() => parseValue(value).number);

  useEffect(() => {
    const parsed = parseValue(value);
    setCode(parsed.code);
    setNumber(parsed.number);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emit = (newCode, newNumber) => {
    onChange(newNumber ? `${newCode} ${newNumber}` : '');
  };

  return (
    <div>
      {label && <label className="block text-sm font-semibold text-[#44474f] mb-1">{label}</label>}
      <div className="flex gap-2">
        <select
          value={code}
          onChange={(e) => { setCode(e.target.value); emit(e.target.value, number); }}
          className="px-2 py-3 rounded-xl border border-[#c4c6d1] bg-[#f7f9fb] outline-none focus:ring-2 focus:ring-[#00255a]/10 text-sm w-[110px] flex-shrink-0"
        >
          {COUNTRY_CODES.map((c) => (
            <option key={c.code} value={c.code}>{c.label}</option>
          ))}
        </select>
        <input
          type="tel"
          required={required}
          value={number}
          onChange={(e) => { const v = e.target.value.replace(/[^\d]/g, ''); setNumber(v); emit(code, v); }}
          placeholder="771234567"
          className="flex-1 px-4 py-3 rounded-xl border border-[#c4c6d1] bg-[#f7f9fb] focus:border-[#00255a] focus:ring-2 focus:ring-[#00255a]/10 outline-none transition-all"
        />
      </div>
    </div>
  );
}